import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

import { Reveal } from '../../../../components/Reveal/Reveal';
import { SectionHeader } from '../../../../components/SectionHeader/SectionHeader';

import ui from '../../../../styles/ui.module.css';
import st from './Audiences.module.css';

export function Audiences({ audiences }) {
  return (
    <section className={`${ui.section} ${st.root}`}>
      <div className={ui.container}>
        <Reveal>
          <SectionHeader
            kicker="Кому"
            title="Курс предназначен для"
            subtitle="Врачей, организаторов здравоохранения, ИТ‑специалистов — и тех, кто отвечает за внедрение ИИ‑решений."
          />
        </Reveal>

        <div className={st.grid}>
          {audiences.map((a, idx) => (
            <Reveal key={a.title} delay={Math.min(idx * 0.03, 0.15)}>
              <div className={`${ui.card} ${st.card}`}>
                <div className={st.head}>
                  <div className={st.icon} aria-hidden="true">
                    <FontAwesomeIcon icon={a.icon} />
                  </div>
                  <div className={st.title}>{a.title}</div>
                </div>
                <div className={st.text}>{a.text}</div>
                <ul className={st.list}>
                  {a.bullets.map((b) => (
                    <li key={b} className={st.listItem}>
                      <FontAwesomeIcon icon={faCircleCheck} className={st.check} />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

